import H1 from '@oneflare/flarekit/lib/components/H1';
import H2 from '@oneflare/flarekit/lib/components/H2';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled, css, ExecutionContext } from 'styled-components';

import { publicRuntimeConfig } from 'lib/utils/Environment';

// The font stack below is used on oneflare pages in order to improve CLS score.
// This is because the system font Tahoma has a similar width to Montserratbold,
// which results in less of a layout shift when the browser switches fonts on load.
const clsFontStack = 'Tahoma, \'Helvetica Neue\', Arial, sans-serif';

const isOneflareDomain = publicRuntimeConfig.DOMAIN === 'oneflare';

type Kind = 'light' | 'primary';

const TitleStyles = css`
  font-size: 28px;
  line-height: 1.5;
  text-align: center;
  margin: 0;
  max-width: 1140px;
  font-weight: 700;
  font-family: ${({ theme }) => (isOneflareDomain ? clsFontStack : theme.font.secondaryBold)};
  ${({ $removeBackground, theme }: ExecutionContext & {
    $removeBackground?: boolean;
  }) => ($removeBackground
    ? `color: ${theme.color.charcoal};
      text-shadow: none;`
    : `color: ${theme.color.white};
      text-shadow: 0 2px 4px rgba(0, 0, 0, 75%);`)
  }

  ${media.smUp`
    color: ${({ theme }) => theme.color.white};
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.75);
    font-size: 28px;
 `}

  ${media.mdUp`
    font-size: 34px;
  `}

  ${({ $kind, theme }: ExecutionContext & {
    $kind?: Kind
  }) => $kind === 'light' && (css`
    color: ${theme.color.tertiary};
    font-size: 28px;
    font-family: ${({ theme }) => (isOneflareDomain ? clsFontStack : theme.font.secondaryBold)};
    font-weight: 700;
    text-shadow: none;

    ${media.mdUp`
       font-size: 40px;
    `}
  `)}
`;

export const TitleH1Styled = styled(H1)<{
  $removeBackground?: boolean;
  $kind?: Kind
}>`
  ${TitleStyles}
`;

export const TitleH2Styled = styled(H2)<{
  $removeBackground?: boolean;
  $kind?: Kind
}>`
  ${TitleStyles}
`;
